import { get } from '../../lib/ajax'

export const Blog = () => ({
  showLoadMore: false,
  isLoadMoreLoading: false,
  currentPage: 1,

  handleLoadMore() {
    this.isLoadMoreLoading = true
    this.currentPage += 1

    const blogUrl = new URL(window.location.href)
    blogUrl.searchParams.set('page', this.currentPage)
    blogUrl.searchParams.set('view', 'article-cards')

    get(blogUrl)
      .then((res) => {
        this.handleNewHTML(res)
        this.updateShowLoadMore()
      })
      .catch((e) => {
        console.error('Error loading more articles:', e)
      })
      .finally(() => {
        this.isLoadMoreLoading = false
      })
  },

  handleNewHTML(res) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(res, 'text/html')
    const newGrid = doc.querySelector('.js-article-grid')
    if (newGrid) {
      this.$refs.articleGrid.append(...newGrid.children)
    }
  },

  updateShowLoadMore() {
    const totalArticles = parseInt(this.$refs.articleGrid.getAttribute('data-article-count'))
    const articlesPerPage = parseInt(this.$refs.articleGrid.getAttribute('data-articles-per-page'))
    const totalPages = Math.ceil(totalArticles / articlesPerPage)
    this.showLoadMore = this.currentPage < totalPages
  },
})
